import React from 'react';
import { twMerge } from 'tailwind-merge';
interface SectionProps {
  id?: string;
  className?: string;
  containerClassName?: string;
  children: React.ReactNode;
  as?: 'section' | 'div';
  ariaLabel?: string;
}
export function Section({
  id,
  className,
  containerClassName,
  children,
  as: Tag = 'section',
  ariaLabel
}: SectionProps) {
  return <Tag id={id} aria-label={ariaLabel} className={twMerge('w-full py-12 md:py-16 lg:py-20', className)} data-id="element-428" data-mp="2r4rhg8od1bta">
      <div className={twMerge('mx-auto w-full max-w-content px-5 md:px-8', containerClassName)} data-id="element-429" data-mp="35t47kp0ro0fv">{children}</div>
    </Tag>;
}
interface EyebrowProps {
  children: React.ReactNode;
  color?: string;
  onDark?: boolean;
  className?: string;
}
export function Eyebrow({
  children,
  color = 'var(--ct-cyan)',
  onDark = false,
  className
}: EyebrowProps) {
  return <span className={twMerge('inline-flex items-center gap-3 font-body text-[11px] font-bold uppercase tracking-[0.17em]', onDark ? 'text-white' : 'text-ct-deep', className)} data-id="element-430" data-mp="1kguef8zrbk9n">
      <span className="h-[2px] w-8" style={{
      background: color
    }} aria-hidden data-id="element-431" data-mp="24ljjlbhgop9w" />
      {children}
    </span>;
}
export function SectionHeading({
  eyebrow,
  eyebrowColor,
  title,
  body,
  align = 'left',
  onDark = false,
  className
}: {
  eyebrow?: string;
  eyebrowColor?: string;
  title: React.ReactNode;
  body?: React.ReactNode;
  align?: 'left' | 'center';
  onDark?: boolean;
  className?: string;
}) {
  return <div className={twMerge('max-w-2xl', align === 'center' && 'mx-auto text-center', className)} data-id="element-432" data-mp="2o9sc5mmx2x9x">
      {eyebrow && <Eyebrow color={eyebrowColor} onDark={onDark} className={align === 'center' ? 'justify-center' : undefined} data-id="element-433" data-mp="2sa2odh1ayjx8">{eyebrow}</Eyebrow>}
      <h2 className={twMerge('mt-5 font-display text-[30px] font-black leading-[1.06] tracking-[-0.025em] md:text-[42px] lg:text-[48px]', onDark ? 'text-white' : 'text-navy')} data-id="element-434" data-mp="2xaqfe2pj70rg">{title}</h2>
      {body && <p className={twMerge('mt-5 text-[16px] leading-relaxed md:text-[18px]', onDark ? 'text-white/72' : 'text-slate')} data-id="element-435" data-mp="12xqubu2dtecs">{body}</p>}
    </div>;
}